import styled from 'styled-components';
import { CustomRatioImage } from '../../../../../components/image/CustomRatioImage';
import CustomBlockButton from '../../../../../components/button/CustomBlockButton';
import { useEffect, useState } from 'react';
import { AddModal } from './modals/add-modal';
import { useReturnExchangeArchivesValueContextHook } from '../../contexts/ReturnExchangeArchivesContext';
import { EditModal } from './modals/edit-modal';
import { DeleteModal } from './modals/delete-modal';

const StyledContainer = styled.div`
    padding: 10px;
`;

const StyledWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(4,1fr);
    gap: 10px;
`;

const StyledCard = styled.div`
    position: relative;
    padding: 10px;
    border: 1px solid #e0e0e0;
    min-height: 100px;
    border-radius: 3px;
    background-color: #fff;

    .title{
        font-size:20px;
        font-weight: 700;
        color:#333;
    }

    .description{
        margin-top: 15px;
        font-size:14px;
        font-weight: 500;
        color:#666;
        min-height: 50px;
        

        display: -webkit-box;        
        -webkit-line-clamp: 3;       
        -webkit-box-orient: vertical;
        overflow: hidden;            
        white-space: pre-wrap;
        word-wrap: break-word;
        line-height: 1.4;            
    }

    .buttons{
        display: flex;
        gap: 10px;
        justify-content: flex-end;

        & button{
            width: 70px;
            height: 38px;
            border-radius: 3px;
            border: 1px solid #333;
            color: #333;
            font-weight: 600;

            &.delete{
                background-color: var(--redColor1);
                border:none;
                color: #fff;
            }
        }
    }
`;

const StyledPlusIcon = styled.div`
    width: 80px;
    height: 80px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    border: 1px dashed #333;
    border-radius: 50%;
`;

export function WegetCardList() {
    const returnExchangeArchivesValueContextHook = useReturnExchangeArchivesValueContextHook();
    const returnExchangeArchives = returnExchangeArchivesValueContextHook?.returnExchangeArchives;

    const [addModalOpen, setAddModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);

    const [selectedArchive, setSelectedArchive] = useState(null);

    const handleOpenEditModal = (archive) => {
        setSelectedArchive(archive);
        setEditModalOpen(true);
    }

    const handleCloseEditModal = () => {
        setSelectedArchive(null);
        setEditModalOpen(false);
    }

    const handleOpenDeleteModal = (archive) => {
        setSelectedArchive(archive);
        setDeleteModalOpen(true);
    }

    const handleCloseDeleteModal = () => {
        setSelectedArchive(null);
        setDeleteModalOpen(false);
    }
    return (
        <>
            <StyledContainer>
                <StyledWrapper>
                    <StyledCard
                        style={{ border: '1px dashed #333', cursor: 'pointer' }}
                        onClick={() => setAddModalOpen(true)}
                    >
                        <StyledPlusIcon>
                            <CustomRatioImage>
                                <CustomRatioImage.Image src="/assets/icons/add_default_000000.svg" alt="placeholder" />
                            </CustomRatioImage>
                        </StyledPlusIcon>
                    </StyledCard>
                    {returnExchangeArchives?.map((item, index) => {
                        return (
                            <StyledCard key={index}>
                                <div className='title'>
                                    {item.name}
                                </div>
                                <div className='description' title={item.description}>
                                    {item.description}
                                </div>
                                <div className='buttons'>
                                    <CustomBlockButton
                                        type='button'
                                        onClick={() => handleOpenEditModal(item)}
                                    >
                                        수정
                                    </CustomBlockButton>
                                    <CustomBlockButton
                                        type='button'
                                        className='delete'
                                        onClick={() => handleOpenDeleteModal(item)}
                                    >
                                        삭제
                                    </CustomBlockButton>
                                </div>
                            </StyledCard>
                        );
                    })}
                </StyledWrapper>
            </StyledContainer>

            {addModalOpen &&
                <AddModal
                    open={addModalOpen}
                    onClose={() => setAddModalOpen(false)}
                />
            }

            {editModalOpen &&
                <EditModal
                    open={editModalOpen}
                    onClose={handleCloseEditModal}
                    selectedArchive={selectedArchive}
                />
            }

            {deleteModalOpen &&
                <DeleteModal
                    open={deleteModalOpen}
                    onClose={handleCloseDeleteModal}
                    selectedArchive={selectedArchive}
                />
            }
        </>
    );
}